if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');
        this.addIdToRecentlyViewed();
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
          this.addIdToRecentlyViewed();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }
       addIdToRecentlyViewed(){
            var handle = this.getAttribute('data-product-handle');
              var url = this.getAttribute('data-url');
              var featuredImage = this.getAttribute('data-img-url');
      
             if (theme.recentlyViewed.recent.hasOwnProperty(handle)) {
                delete theme.recentlyViewed.recent[handle];
              }
        
              // Add it back to the end
              theme.recentlyViewed.recent[handle] = {
                url: url,
                featuredImage: featuredImage
              };
             
                window.localStorage.setItem('theme-recent', JSON.stringify(theme.recentlyViewed.recent));
              
          }
      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        // this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            // this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}

/* NXF-Fix: Variantenwahl (Farbe/Größe) auf der Produktseite.
   1) Beim Wechsel der Auswahl die Options-Buttons neu vom Server laden (VariantRadios in global.js setzt sonst nur
      "disabled" auf die beim Seitenaufruf gelieferten Buttons). So bleiben Durchstreichungen und Größenlisten korrekt.
   2) Farbe gewählt, aber in der gewählten Größe ausverkauft: Auswahl springt auf die nächste Größe, in der sie lieferbar ist.
   3) Größe gewählt (Größe steht vor Farbe): die gewählte Farbe bleibt, ist die Kombination ausverkauft, zeigt der Button das;
      die Durchstreichungen der Größen werden dabei zur gewählten Farbe neu geladen.
   4) Danach das Größenhilfe-Skript informieren (es lauscht auf change-Ereignisse und würde sonst veraltete Maße zeigen).
   Rückweg: diesen Block wieder löschen. */
(function () {
  if (window.__nxfOptionFix) return;
  window.__nxfOptionFix = true;
  var token = 0;

  function resync() {
    var d = document.createElement('input');
    d.type = 'radio';
    d.hidden = true;
    document.body.appendChild(d);
    d.dispatchEvent(new Event('change', { bubbles: true }));
    d.remove();
  }

  function refresh(fs, text, from) {
    var nf = new DOMParser().parseFromString(text, 'text/html').querySelectorAll('variant-radios fieldset');
    var ok = nf.length === fs.length, i;
    for (i = from; ok && i < fs.length; i++) ok = !!nf[i].querySelector('input:checked');
    if (ok) for (i = from; i < fs.length; i++) fs[i].innerHTML = nf[i].innerHTML;
    return ok;
  }

  document.addEventListener('change', function (e) {
    var el = e.target.closest && e.target.closest('variant-radios');
    if (!el) return;
    var fs = el.querySelectorAll('fieldset');
    if (fs.length < 2) return;
    var orig = customElements.get('variant-radios').prototype.onVariantChange;
    var colorFirst = fs[0].classList.contains('farbe');
    var target, from, fake = false, sizeInput;

    try {
      var data = el.getVariantData();
      if (fs[0].contains(e.target)) {
        // Erste Option geändert
        var old = fs[1].querySelector('input:checked');
        var same = data.filter(function (v) { return v.option1 === e.target.value; });
        var exact = old && same.find(function (v) { return v.option2 === old.value; });
        var avail =
          same.find(function (v) { return old && v.option2 === old.value && v.available; }) ||
          same.find(function (v) { return v.available; });
        target = !colorFirst && exact ? exact : avail; // Größe zuerst: Farbe bleibt; Farbe zuerst: lieferbare Variante
        from = colorFirst ? 1 : 0; // Größe zuerst: auch die Größen neu laden (Durchstreichen hängt an der Farbe)
        fake = !colorFirst;
      } else if (!colorFirst && fs[1].contains(e.target) && fs[1].classList.contains('farbe')) {
        // Farbe (zweite Option) gewählt
        var cur = fs[0].querySelector('input:checked');
        var sizes = Array.prototype.map.call(fs[0].querySelectorAll('input'), function (i) { return i.value; });
        var curIdx = sizes.indexOf(cur && cur.value);
        var now = cur && data.find(function (v) { return v.option1 === cur.value && v.option2 === e.target.value; });
        if (now && now.available) {
          target = now;
        } else {
          var cands = data.filter(function (v) { return v.option2 === e.target.value && v.available; });
          cands.sort(function (a, b) {
            return Math.abs(sizes.indexOf(a.option1) - curIdx) - Math.abs(sizes.indexOf(b.option1) - curIdx) ||
              sizes.indexOf(a.option1) - sizes.indexOf(b.option1);
          });
          target = cands[0];
        }
        from = 0;
        fake = true;
        if (target) {
          sizeInput = Array.prototype.find.call(fs[0].querySelectorAll('input'), function (i) { return i.value === target.option1; });
          if (!sizeInput) return;
        }
      } else {
        token++; // andere Änderung: laufende Aktualisierung verwerfen
        return;
      }
    } catch (err) { return; }

    if (!target) return; // nichts kaufbar: Theme verhält sich wie bisher
    e.stopPropagation();
    var my = ++token;
    if (sizeInput) sizeInput.checked = true;
    var fakeIdx = fs[0].contains(e.target) ? 0 : 1;
    var ev = function () { return fake ? { target: fs[fakeIdx].querySelector('input:checked') || e.target } : e; };
    fetch(el.dataset.url + '?variant=' + target.id + '&section_id=' + el.dataset.section)
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (t) {
        if (my !== token) return; // veraltete Antwort bei schnellem Klicken
        refresh(fs, t, from);
        orig.call(el, ev());
        resync();
      })
      .catch(function () { orig.call(el, ev()); });
  }, true);
})();
